/** Palette & styles partagés (pages + composants) */
export const BRAND = {
  ink: '#0c3d72',
  forest: '#0c3d72',
  leaf: '#0c3d72',
  gold: '#0c3d72',
  goldSoft: '#ffffff',
  sand: '#f3f5f8',
  mist: '#f4f6f9',
  muted: '#5c5c5c',
  line: 'rgba(12, 61, 114, 0.14)',
  veil: 'rgba(12, 61, 114, 0.52)',
  band: 'rgba(12, 61, 114, 0.82)'
};

export const HERO_GRADIENT = `linear-gradient(160deg, rgba(12, 61, 114, 0.92) 0%, rgba(12, 61, 114, 0.72) 100%)`;
export const BTN_GRADIENT = `rgba(12, 61, 114, 0.86)`;
export const FONT_DISPLAY = '"Fraunces", Georgia, serif';
export const FONT_SANS = '"Manrope", "Segoe UI", sans-serif';
